import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminPublishMADBs = () => {
  const queryClient = useQueryClient();

  return apiClient.madb.publishMadb.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-catalogs-info'] });
      toast.success('MADBs published successfully');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to publish MADBs');
    },
  });
};
